const TedWhitePlus = () => (
  <div>
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.16699 12.0013C7.16699 12.7377 7.76395 13.3346 8.50033 13.3346C9.2367 13.3346 9.83366 12.7377 9.83366 12.0013V9.33464H12.5003C13.2367 9.33464 13.8337 8.73768 13.8337 8.0013C13.8337 7.26492 13.2367 6.66797 12.5003 6.66797H9.83366V4.0013C9.83366 3.26492 9.2367 2.66797 8.50033 2.66797C7.76395 2.66797 7.16699 3.26492 7.16699 4.0013V6.66797L4.50033 6.66797C3.76395 6.66797 3.16699 7.26492 3.16699 8.0013C3.16699 8.73768 3.76395 9.33463 4.50033 9.33463L7.16699 9.33464V12.0013Z"
        stroke="#545454"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
    </svg>
  </div>
);
export default TedWhitePlus;
